export const SECTION = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.SectionWidgetElement';
